module.exports = __webpack_public_path__ + "img/Gold.c625b7c9.png";